export const PRODUCTS_LIST = 'PRODUCTS_LIST';